const APIEndpoint = `https://www.nacdharamgarh.in/backend/api`

export const homePageURI = `/get_homepage_data/`
export const organogramURI = `/list_members/`
export const whatsNewURI = `/list_whats_new/`
export const downloadsURI = `/list_downloads/`
export const galleryURI = `/list_gallery/`
export const tendersURI = `/list_tenders/`
export const publicDisclosureURI = `/list_public_disclosures/`

// GET
export const get_REST_API = (endpoint, callback) => {
	fetch(`${APIEndpoint}${endpoint}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	})
		.then(res => {
			if (!res.ok) {
				throw new Error("HTTP status " + res.status);
			}
			return res.json()
		})
		.then(response => callback(response))
		.catch(err => callback(new Error(err)))
}

//POST
export const submitCesspool = (data, callback) => {

	fetch(`${APIEndpoint}/add_cesspool_vehicle_booking/`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	})
		.then(res => {
			if (!res.ok) {
				throw new Error("HTTP status " + res.status);
			}
			return res.json()
		})
		.then(response => callback(response))
		.catch(err => callback(new Error(err)))

}

export const submitKalyaanMandap = (data, callback) => {

	fetch(`${APIEndpoint}/add_kalyan_mandap_booking/`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	})
		.then(res => {
			if (!res.ok) {
				throw new Error("HTTP status " + res.status);
			}
			return res.json()
		})
		.then(response => callback(response))
		.catch(err => callback(new Error(err)))
}


export const submitGrievance = (data, callback) => {

	fetch(`${APIEndpoint}/add_grievance/`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	})
		.then(res => {
			if (!res.ok) {
				throw new Error("HTTP status " + res.status);
			}
			return res.json()
		})
		.then(response => callback(response))
		.catch(err => callback(new Error(err)))
}
